/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Card, Form, Button, Spin, Radio, Space, Checkbox, Input, Select, message } from 'antd';

import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { getUserData } from '../../../helpers/functions';
import { IoMdArrowRoundBack } from 'react-icons/io';
import { a } from 'react-spring';
import { getRequest } from '../../../helpers/apiCall';
import { use } from 'react';

const Languages = ({ handleNext, handleBack }) => {
  const dispatch = useDispatch();
  const { eid } = useParams();
  const [form] = Form.useForm();
  const { isLangLoading, languageList } = useSelector(state => state.common);
  const { isExpertUpdating, stepExpertMsg } = useSelector(state => state.steps);
  const { isExpertInfoLoading, expertDetails } = useSelector(state => state.expert);
  const [unpublishedLanguages, setUnpublishedLanguages] = useState([]);
  const [defaultCustomLanguage, setDefaultCustomLanguage] = useState([]);
  useEffect(() => {
    if (eid || getUserData().id) {
      dispatch({ type: 'EXPERT_DETAIL_REQUEST', id: eid || getUserData().id });
    }
    dispatch({ type: 'GET_LANGUAGE_REQUEST', formData: { status: 'active' } });
  }, []);
  const getUnpublishedLanguages = async () => {
    try {
      const resp = await getRequest('unpublishlanguages');
      setUnpublishedLanguages(resp?.data);
    } catch (error) {
      message.error('Could not get unpublished languages');
    }
  };
  const onChange = e => {};
  useEffect(() => {
    getUnpublishedLanguages();
  }, []);
  useEffect(() => {
    if(expertDetails?.languages?.length > 0){
      let defaultCustomLanguage = expertDetails.languages.filter(i => i.status === 'unpublish');
      defaultCustomLanguage = defaultCustomLanguage.map(i => {
        return i.name
      })
      if(defaultCustomLanguage.length > 0){
            setDefaultCustomLanguage(defaultCustomLanguage);
            setCustomLanguage(true)
            form.setFieldValue('custom_language', JSON.stringify(defaultCustomLanguage))
      }
  
    }
  },[expertDetails])
  useEffect(() => {
    if (
      !isExpertInfoLoading &&
      Object.keys(expertDetails).length > 0 &&
      !isLangLoading &&
      languageList.length > 0
    ) {
      let tmpIds =
        expertDetails.languages !== null && expertDetails.languages.length
          ? expertDetails.languages.map(i => i.id)
          : [];
      form.setFieldsValue({ language_ids: tmpIds });
    }
  }, [isExpertInfoLoading, expertDetails, isLangLoading, languageList]);

  const onFinish = values => {
    let allLanguages = languageList.filter(i => values.language_ids.includes(i.id));
    allLanguages = allLanguages.map(i => {
      return i.name;
    });
    let customLang = values?.custom_language ? JSON.parse(values?.custom_language) : [];
    allLanguages = [...allLanguages, ...customLang];
    allLanguages = allLanguages.map(i => {
      return i.toLowerCase();
    });
    allLanguages = [...new Set(allLanguages)];
    if(allLanguages.length === 0){
      message.error('Please select at least one language');
      return
    }
    dispatch({
      type: 'EXPERT_STEP_UPDATE_REQUEST',
      formData: {
        language: allLanguages,
        // custom_language: JSON.parse(values.custom_language),
        expert_id: eid || getUserData().id,
      },
      requestType: 'put',
      step: 'language',
    });
  };

  useEffect(() => {
    if (!isExpertUpdating && stepExpertMsg === 'success') {
      handleNext('experience');
      dispatch({ type: 'CLEAR_STEPS' });
    }
  }, [isExpertUpdating, stepExpertMsg]);
  const [customlanguage, setCustomLanguage] = useState(false);
  return (
    <div>
      <div className="site-card-border-less-wrapper card-wrapper">
        <Card bordered={false}>
          {isLangLoading && <Spin />}
          {!isLangLoading && (
            <>
              <p className="m-title tl mb-7 d-flex-center">
                <span className="back-icon" onClick={() => handleBack('language')}>
                  <IoMdArrowRoundBack />
                </span>
                <span>Language I speak </span>
              </p>

              <Form
                layout="vertical"
                name="basic"
                initialValues={{ remember: true }}
                form={form}
                onFinish={onFinish}
                onError={error => console.log(error)}
              >
                <Form.Item
                  name="language_ids"
                  
                >
                  <Checkbox.Group className={'mt3'} style={{ width: '100%' }} onChange={onChange}>
                    <Space direction="vertical" size={'middle'} style={{ width: '100%' }}>
                      {!isLangLoading &&
                        languageList.map(item => {
                          return (
                            <>
                              <Checkbox key={item.id} value={item.id}>
                                {' '}
                                {item.name}
                              </Checkbox>
                            </>
                          );
                        })}
                    </Space>
                  </Checkbox.Group>
                </Form.Item>
                <Button
                  style={{ marginBottom: '1rem' }}
                  onClick={() => setCustomLanguage(!customlanguage)}
                  type={!customlanguage ? '' : 'primary'}
                >
                  Add Custom Language
                </Button>
                {customlanguage && (
                  <>
                    <Form.Item
                      style={{ display: 'none' }}
                      label="Enter Language"
                      name="custom_language"
                 
                    >
                      <Input />
                    </Form.Item>
                    <Select
                      mode="tags"
                      size={'middle'}
                      placeholder="Please Enter Language"
                      onChange={e => {
                        form.setFieldsValue({ custom_language: JSON.stringify(e) });
                      }}
                      style={{ width: '100%' }}
                      defaultValue={defaultCustomLanguage}
                      options={unpublishedLanguages?.data?.map(item => {
                        return {
                          label: item.name,
                          value: item.name,
                        };
                      })}
                    />
                  </>
                )}
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    size="middle"
                    className="mt-5"
                    disabled={isExpertUpdating}
                    loading={isExpertUpdating}
                  >
                    Next
                  </Button>
                </Form.Item>
              </Form>
            </>
          )}
        </Card>
      </div>
    </div>
  );
};
export default Languages;
